import { render, staticRenderFns } from "./LessonQuiz.vue?vue&type=template&id=01ea0b60&scoped=true&"
import script from "./LessonQuiz.vue?vue&type=script&lang=js&"
export * from "./LessonQuiz.vue?vue&type=script&lang=js&"
import style0 from "./LessonQuiz.vue?vue&type=style&index=0&id=01ea0b60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ea0b60",
  null
  
)

export default component.exports